import React from 'react';
import { NavigateFunction } from 'react-router-dom';
import { CellContext } from '@tanstack/react-table';
import { utcToZonedTime } from 'date-fns-tz';

import { AdaptiveTableCell } from '@components/common';
import Actions from '@components/common/Actions';

import { formatDate } from '@utils/kpi-utils/date';

import { formatTemplateWithTime, timezoneUTC } from '@constants/common';
import { projectProfilePath } from '../Projects/constants';

export const getColumns = ({ navigate }: { navigate: NavigateFunction }) => ([
	{
		header: 'Project name',
		accessorKey: 'name',
		cell: ({ getValue }: CellContext<any, any>) => {
			const name = getValue();

			return <AdaptiveTableCell text={name} />;
		},
	},
	{
		header: 'Project code',
		accessorKey: 'code',
		cell: ({ getValue }: CellContext<any, any>) => {
			const code = getValue();

			return <AdaptiveTableCell text={code} />;
		},
	},
	{
		header: 'Status',
		accessorKey: 'status',
		cell: ({ getValue }: CellContext<any, any>) => {
			const status = getValue();

			return <AdaptiveTableCell text={status?.title} />;
		},
	},
	{
		header: 'Project admins',
		accessorKey: 'admins',
		enableSorting: false,
		cell: ({ getValue }: CellContext<any, any>) => {
			const value = getValue();
			const admins = value?.map(({ fullName }: { fullName: string }) => fullName).join(', ');

			return <AdaptiveTableCell text={admins} />;
		},
	},
	{
		header: 'Created',
		accessorKey: 'createdAt',
		cell: ({ getValue }: CellContext<any, any>) => {
			const createdAt = getValue();
			const date = createdAt ? formatDate(utcToZonedTime(createdAt, timezoneUTC), formatTemplateWithTime) : '';

			return <AdaptiveTableCell text={date} />;
		},
	},
	{
		header: 'Updated',
		accessorKey: 'updatedAt',
		cell: ({ getValue }: CellContext<any, any>) => {
			const updatedAt = getValue();
			const date = updatedAt ? formatDate(utcToZonedTime(updatedAt, timezoneUTC), formatTemplateWithTime) : '';

			return <AdaptiveTableCell text={date} />;
		},
	},
	{
		header: 'Actions',
		accessorKey: 'id',
		enableSorting: false,
		cell: ({ getValue }: CellContext<any, any>) => {
			const id = getValue();
			const openProfileHandler = () => navigate(`${projectProfilePath}/${id}`);

			return (
				<Actions
					gridNumberOfColumns={1}
					isView
					viewHandler={openProfileHandler}
				/>
			);
		},
	},
]);
